// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"2afb3908","990":"137038c1"}[chunkId] + ".chunk.js";
};